import associations from "../../../../mobile/link_association_gate.json"

export const appLinkEnvironment = (apiBase: string) => {
  if (apiBase === "https://api.dev.cashhub.boemyoung.co.kr") return "dev"
  if (apiBase === "https://api.cashhub.boemyoung.co.kr") return "prod"
  return null
}

export const androidAssociation = (environment: "dev" | "prod") => {
  const { packageName, certificateSha256 } = associations.android.environments[environment]
  return [{ relation: ["delegate_permission/common.handle_all_urls"], target: { namespace: "android_app", package_name: packageName, sha256_cert_fingerprints: [certificateSha256.match(/.{2}/g)?.join(":").toUpperCase()] } }]
}

export const appleAssociation = (environment: "dev" | "prod") => {
  const { appleTeamId, bundleId } = associations.ios.environments[environment]
  return { applinks: { details: [{ appIDs: [`${appleTeamId}.${bundleId}`], components: [{ "/": "/entry" }] }] } }
}
